import { createRouter, createWebHistory } from 'vue-router';

import DashboardView from '@/views/DashboardView.vue';
import KassaView from '@/views/KassaView.vue';
import ClientsAndDiscountsView from "@/views/ClientsAndDiscountsView.vue";
import CatalogAndSuppliesView from '@/views/CatalogAndSuppliesView.vue';
import StaffView from '@/views/StaffView.vue';
import PricingView from "@/views/PricingView.vue";
import PersonalAccountView from '@/views/PersonalAccountView.vue';
import SignUpView from "@/views/SignUpView.vue";
import SignInView from "@/views/SignInView.vue";
import ChooseRoleView from "@/views/ChooseRoleView.vue";
import AccountConfirmationView from "@/views/AccountConfirmationView.vue";
import CreateCompanyView from "@/views/CreateCompanyView.vue";
import ResetPasswordView from "@/views/ResetPasswordView.vue";
import ResetPhoneView from "@/views/ResetPhoneView.vue";
import ChooseCompanyView from "@/views/ChooseCompanyView.vue";
import ResetEmailContinueView from "@/views/ResetEmailContinueView.vue";
import ResetEmailFinalView from "@/views/ResetEmailFinalView.vue";
import PageNotFoundView from "@/views/PageNotFoundView.vue";


const routes = [
  {
    path: '/dashboard/',
    name: 'dashboard',
    component: DashboardView,
    meta: {
      title: "Кассы",
    },
  },
  {
    path: '/kassa/',
    name: 'kassa',
    component: KassaView,
    meta: {
      title: "Касса",
    },
  },
  {
    path: "/clients/",
    name: "clients",
    component: ClientsAndDiscountsView,
    meta: {
      title: "Клиенты",
    },
  },
  {
    path: "/catalog/",
    name: "catalog",
    component: CatalogAndSuppliesView,
    meta: {
      title: "Каталог",
    },
  },
  {
    path: "/staffs/",
    name: "staffs",
    component: StaffView,
    meta: {
      title: "Сотрудники",
    },
  },
  {
    path: "/schedule-and-salary/",
    name: "schedule-and-salary",
    component: StaffView,
    meta: {
      title: "Графики и зарплаты",
    },
  },
  {
    path: "/pricing/",
    name: "pricing",
    component: PricingView,
    meta: {
      title: "Тарифы",
    },
  },
  {
    path: "/account/",
    name: "account",
    component: PersonalAccountView,
    meta: {
      title: "Личный кабинет",
    },
  },
  {
    path: "/sign-up/",
    name: "sign-up",
    component: SignUpView,
    meta: {
      title: "Регистрация аккаунта",
    }
  },
  {
    path: "",
    name: "sign-in",
    component: SignInView,
    meta: {
      title: "Вход в систему",
    }
  },
  {
    path: "/role/",
    name: "role",
    component: ChooseRoleView,
    meta: {
      title: "Выбор роли",
    }
  },
  {
    path: "/confirm/",
    name: "account-confirmation",
    component: AccountConfirmationView,
    meta: {
      title: "Подтверждение аккаунта",
    }
  },
  {
    path: "/reset-password/",
    name: "reset-password",
    component: ResetPasswordView,
    meta: {
      title: "Cброс пароля",
    }
  },
  {
    path: "/reset-phone/",
    name: "reset-phone",
    component: ResetPhoneView,
    meta: {
      title: "Обновление номера телефона",
    }
  },
  {
    path: "/reset-email/",
    name: "reset-email-continue",
    component: ResetEmailContinueView,
    meta: {
      title: "Обновление email",
    }
  },
  {
    path: "/reset-email/final/",
    name: "reset-email-final",
    component: ResetEmailFinalView,
    meta: {
      title: "Подтверждение обновления email",
    }
  },
  {
    path: "/create-company/",
    name: "create-company",
    component: CreateCompanyView,
    meta: {
      title: "Создание компании",
    }
  },
  {
    path: "/choose-company/",
    name: "choose-company",
    component: ChooseCompanyView,
    meta: {
      title: "Выбор компании",
    }
  },
  { 
    path: '/:catchAll(.*)', 
    name: "page-not-found",
    component: PageNotFoundView,
    meta: {
      title: "Страница не найдена"
    }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || 'QKASSA';
  next();
});

export default router
